import { Check } from "lucide-react";
import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import { SERVICES } from "@/data/services";
import { PAGE_META } from "@/lib/seo-constants";
import { serviceSchema, breadcrumbSchema } from "@/lib/jsonld";
import { MAILTO_HREF } from "@/lib/constants";

export default function Services() {
  const meta = PAGE_META.services;

  return (
    <>
      <Seo
        title={meta.title}
        description={meta.description}
        path={meta.path}
        jsonLd={[
          ...SERVICES.map(serviceSchema),
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Services", path: "/services" },
          ]),
        ]}
      />

      <Hero
        image="/images/service-masonry.jpg"
        imageAlt="Bricklayer's hands applying mortar between bricks on a commercial wall"
        eyebrow="Services"
        title="Masonry, Siding & Full Project Delivery"
        subtitle="Two trades we know inside out, wrapped in the project management to bring any commercial or industrial job home on time."
        ctaLabel={null}
        size="small"
      />

      {SERVICES.map((service, index) => (
        <section
          key={service.slug}
          id={service.anchor}
          className={`scroll-mt-24 py-20 ${index % 2 === 1 ? "bg-white" : ""}`}
        >
          <div className="section-container">
            <div
              className={`grid grid-cols-1 items-center gap-12 md:grid-cols-2 ${
                index % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div>
                <p className="font-display text-sm uppercase tracking-[0.3em] text-brick">
                  {String(index + 1).padStart(2, "0")}
                </p>
                <h2 className="mt-3 font-display text-3xl font-semibold text-charcoal sm:text-4xl">
                  {service.name}
                </h2>
                <p className="mt-4 text-steel">{service.summary}</p>
                <ul className="mt-6 space-y-3">
                  {service.bullets.map((bullet) => (
                    <li key={bullet} className="flex items-start gap-3">
                      <Check size={20} className="mt-0.5 shrink-0 text-brick" />
                      <span className="text-charcoal">{bullet}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href={MAILTO_HREF}
                  className="mt-8 inline-block rounded bg-brick px-7 py-3.5 font-display text-sm uppercase tracking-wide text-offwhite transition-colors hover:bg-brick-light"
                >
                  Discuss This Service
                </a>
              </div>
              <div className="overflow-hidden rounded-lg shadow-lg">
                <img
                  src={service.image}
                  alt={service.imageAlt}
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>
      ))}
    </>
  );
}
